const EMAIL = {
  EMAIL: 'asiakaspalvelu@advisa.fi',
};

export default EMAIL;
